import React from 'react';
import { ByDevice } from './ByDevice';
import RedesignD from './d';
import RedesignM2 from './m2';

/** The pepes.dog home: design D on wide screens, the m2 chapters on phones and narrow windows. */
const Home: React.FC = () => <ByDevice desktop={RedesignD} mobiles={{ m2: RedesignM2 }} fallback="m2" />;

export default Home;
